/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Page, WKError} from '../components';
import {WKPreload} from '../components/wk';
import {ComplainAccount, ComplainBody} from '../components/complain';
import '../css/page/ComplainReasonPage.css';
import errorImg from '../images/no-source.png';


class ComplainReasonPage extends Component {
    constructor() {
        super();
        this.state = {
            initialized: false,
            data: {},
            liveroom: {},
            createAccount: {},
            isFromQuestion: false,
        };
    }

    componentDidMount() {
        const {id, type} = this.props.params;
        if (id == 0 && type == 0) {
            return this.setState({
                initialized: true,
                isFromQuestion: true,
            })
        }
        axios.get(`/api/${type}/${id}/short_info`).then(res => {
            if (res.data.code === 0) {
                if (type === 'lecture') {
                    this.setState({
                        initialized: true,
                        data: res.data.data.lecture,
                        liveroom: res.data.data.liveroom,
                        createAccount: res.data.data.lecture_account
                    });
                }
                if (type === 'channel') {
                    this.setState({
                        initialized: true,
                        data: res.data.data.channel,
                        liveroom: res.data.data.liveroom,
                        createAccount: res.data.data.channel_account
                    });
                }
            }
        }).catch(error => {
            let tips = '';
            if (error.response && error.response.status === 404) {
                tips = '课程/专栏不存在';
            } else {
                tips = '服务器繁忙，稍后再试试吧';
            }
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: tips,
                    img: errorImg,
                    href: '/?fr=error',
                    btn: '回到首页'
                }
            });
            console.log(error);
        });
    }

    render() {
        const {initialized, data, liveroom, createAccount, isFromQuestion} = this.state;
        const {id, type, category} = this.props.params;
        const {error} = this.props;

        if (error.showError) {
            return <div className="wk-inner-page"><WKError/></div>
        }
        if (!initialized) {
            return <WKPreload />;
        }

        return (
            <Page className="complain-reason-page">
                <div className="wk-inner-page">
                    {
                        !isFromQuestion && (
                            <ComplainAccount data={data} liveroom={liveroom} createAccount={createAccount}/>
                        )
                    }
                    <ComplainBody isFromQuestion={isFromQuestion} id={id} type={type} category={category}/>
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({
    error: state.error
}))(ComplainReasonPage)


// WEBPACK FOOTER //
// ./src/pages/ComplainReasonPage.js